import { Version } from "./version";

export const TEMPLATE_VERSION = new Version('14.1.1').full;